$(document).ready(function(){
  // Add smooth scrolling to all links
  $("#scroll-to-contact").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1500, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = hash;
      });
    } // End if
  });

  $(".index-shop-col").click(function () {
   window.location.href='/collections/numa-postpartum-products';
  });

  $("#product-learn-more, #product-testimonials-link").on('click', function(event) {
    console.log('click');

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1000, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = hash;
      });
    } // End if
  });

  /*mobile menu**/
  $(".open-fresh-menu").click(function() {
    $(".fresh-mobile-menu, .fresh-mobile-menu-cover").toggle();
    $(".fresh-mobile-menu").animate({'right': '+=60%'});
    $(".fresh-mobile-menu-cover").animate({'left': '+=40%'});
    
  })
  $(".close-fresh-menu, .fresh-mobile-menu-cover").click(function() {
    $(".fresh-mobile-menu").animate({'right': '-=60%'});
    $(".fresh-mobile-menu").toggle();
    $(".fresh-mobile-menu-cover").animate({'left': '-=40%'});
    
  })  

  //product form questions gift message
  // $('#is-this-a-gift').click(function() {
  //     $("#box-gift-message").toggle();
  // });
  $('.fresh-gift-yes').click(function() {
      $("#box-gift-message").show();
  });  
$('.fresh-gift-no').click(function() {
      $("#box-gift-message").hide();
  });    


  //product page description
  $(".product-page-header").click(function() {
    $(this).next().slideToggle("slow");
    $(this).children("span").toggleClass('transform-span');
  });

  //indicator dots
  if ( $(".testimonial-wrapper .testimonial-col:last-child").is(":visible"))  {
    console.log('visible');
  }
  

  //product page thumbnails
  $(".flex-control-thumbs li img").click(function() {
    $(this).addClass('li-dot-filler');
    console.log('heyyyyy');
  });
  

  //product pagebuy button
  $('#product-popup-trigger button').click(function() {
      // $(this).toggleClass('product-popup-trigger-clicked').slideUp();
      $(this).hide();
      $("#product-page-form").slideToggle("slow");
  });


  



  //what's in the kit product page
  $('.guide-section-col.tank-top').click(function() {
    $('#product-page-guide-section-overlay.tank-top').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.tank-top').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });

  $('.guide-section-col.numa-peri-bottle').click(function() {
    $('#product-page-guide-section-overlay.numa-peri-bottle').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.numa-peri-bottle').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });  

  $('.guide-section-col.underwear').click(function() {
    $('#product-page-guide-section-overlay.underwear').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.underwear').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });  

  $('.guide-section-col.honeypot-pads').click(function() {
    $('#product-page-guide-section-overlay.honeypot-pads').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.honeypot-pads').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });  

  $('.guide-section-col.hazel-pads').click(function() {
    $('#product-page-guide-section-overlay.hazel-pads').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.hazel-pads').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });  

  $('.guide-section-col.water-bottle').click(function() {
    $('#product-page-guide-section-overlay.water-bottle').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.water-bottle').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });  

  $('.guide-section-col.nipple-cream').click(function() {
    $('#product-page-guide-section-overlay.nipple-cream').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.nipple-cream').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });            

  $('.guide-section-col.tea').click(function() {
    $('#product-page-guide-section-overlay.tea').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.tea').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });  

  $('.guide-section-col.chocolate').click(function() {
    $('#product-page-guide-section-overlay.chocolate').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.chocolate').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });  

  $('.guide-section-col.stool-softener').click(function() {
    $('#product-page-guide-section-overlay.stool-softener').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.stool-softener').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });      

  $('.guide-section-col.headband').click(function() {
    $('#product-page-guide-section-overlay.headband').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.headband').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });        

  $('.guide-section-col.toy-holder').click(function() {
    $('#product-page-guide-section-overlay.toy-holder').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.toy-holder').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });     

  $('.guide-section-col.guidebook').click(function() {
    $('#product-page-guide-section-overlay.guidebook').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.guidebook').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });      

  $('.guide-section-col.gift-card').click(function() {
    $('#product-page-guide-section-overlay.gift-card').fadeIn(300);  
    $('.header').addClass("header-zindex");
    $('body').addClass("overflow-y-hidden");
  });
  $('#product-page-guide-section-close, #product-page-guide-section-overlay').click(function() {
      $('#product-page-guide-section-overlay.gift-card').fadeOut(300);
      $('.header').removeClass("header-zindex");
      $('body').removeClass("overflow-y-hidden");
  });   


  //kit comparison chart        
  $('#kit-also-viewed .kit-link').click(function() {
    $('#kit-comparison-chart').show();
  });
  $('#kit-comparison-chart #close').click(function() {
    $('#kit-comparison-chart').hide();
  });  

  //symptoms page
  $('.more-symptom-button').click(function() {
    $('#symptoms-guide').show();
    $('.sub-footer').hide();
    $('body').addClass('no-scroll');
  });
  $('span.symptoms-guide-close').click(function() {
    $('#symptoms-guide').hide();
    $('.sub-footer').show();
    $('body').removeClass('no-scroll');
  });  
  

  $('.symptoms-guide-col-header').click(function() {

    //show content, hide other content
    $(this).next().toggle('25');
    $(".symptoms-guide-col-content").not($(this).next()).slideUp('500');

    // plus minus toggle      
    $(this).find("span.symptoms-question-plus").toggle();
    $(this).find("span.symptoms-question-minus").toggle();
    $("span.symptoms-question-plus").not($(this).find("span.symptoms-question-plus")).show();
    $("span.symptoms-question-minus").not($(this).find("span.symptoms-question-minus")).hide();

  });
  

});

